import { CustomError } from "./customError";
import { Bounce, ToastContainer, toast } from 'react-toastify';

class ErrorHandler {
  handleErrorAlert(error) {
    const errorMessage = error instanceof CustomError ? error.msg : "An unexpected error occurred.";
    toast.error(errorMessage, {
      position: "bottom-center",
      autoClose: 15000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  }
}

const errorHandler = new ErrorHandler();
export default errorHandler;